module.exports = __webpack_public_path__ + "img/商贩管理.348a89f4.png";